const config: siteConfig = {
  REACT_APP_API_URL: "http://localhost/sds_efl_backend/api",
  ENCRYPTION_KEY: "your-secret-key",
  DIGI_SERVER_URL: "https://sds.softdigisolutions.com/",
};

export default config;
